const AppTitle = () => {
  return (
    <div className="px-3 py-3">
      <a href="/">
        <h1 className="text-4xl font-extrabold leading-none mb-0">UK AIR</h1>
        <p className="font-medium">Air Information Resource</p>
      </a>
    </div>
  );
};

export default AppTitle;
